import { useState, useEffect } from 'react'
import { Link } from '@remix-run/react'
import { getGlobal } from '~/utils'
import { NavLink, Button, OffcanvasNav } from '~/components'
import { Bars3Icon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/solid'

const Header = () => {
  const { site } = getGlobal()
  const [offcanvasOpen, setOffcanvasOpen] = useState<boolean>(false)
  const primaryNav = site?.settings?.primaryNavigation
    ? site.navigations.find(e => e._id == site.settings.primaryNavigation._ref)
    : null

  useEffect(() => {
    if (offcanvasOpen) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }, [offcanvasOpen])

  return (
    <>
      <div className="fixed top-0 z-50 h-24 w-full bg-gradient-to-b from-fc-green/90 to-fc-green/0">
        <div className="container my-auto flex h-full items-center justify-between">
          <div className="flex w-full items-center justify-between xl:hidden">
            {site?.global?.logo?.asset?.url && (
              <Link to="/">
                <img
                  className="max-h-8"
                  src={site.global.logo.asset.url}
                  alt={site.global.logo?.alt}
                />
              </Link>
            )}
            <button
              onClick={() => {
                setOffcanvasOpen(true)
              }}
            >
              <Bars3Icon className="size-8 text-white" />
            </button>
          </div>
          <div className="hidden w-full items-center justify-between xl:flex">
            <div className="flex items-center justify-start gap-5">
              <div className="mr-5">
                {site?.global?.logo?.asset?.url && (
                  <Link to="/">
                    <img
                      className="max-h-12"
                      src={site.global.logo.asset.url}
                      alt={site.global.logo?.alt}
                    />
                  </Link>
                )}
              </div>
              {primaryNav?.items &&
                primaryNav.items.map((item, i) => (
                  <NavLink
                    key={i}
                    className="text-sm text-white"
                    {...item}
                  />
                ))}
            </div>
            <div className="flex items-center justify-start gap-5">
              {site.global.phoneNumber && (
                <a
                  href={`tel:${site?.global?.phoneNumber}`}
                  className="flex items-center gap-2 text-sm text-white"
                >
                  <PhoneIcon className="size-4" />
                  {site.global.phoneNumber}
                </a>
              )}
              {site.global.emailAddress && (
                <a
                  href={`mailto:${site?.global?.emailAddress}`}
                  className="flex items-center gap-2 text-sm text-white"
                >
                  <EnvelopeIcon className="size-4" />
                  {site.global.emailAddress}
                </a>
              )}
              {site.global.buttons &&
                site.global.buttons.map((button, i) => (
                  <Button
                    key={i}
                    size="text-sm"
                    {...button}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
      {primaryNav?.items && (
        <OffcanvasNav
          open={offcanvasOpen}
          items={primaryNav.items}
          setOpen={setOffcanvasOpen}
        />
      )}
    </>
  )
}

export default Header
